<template>
  <div>
    <el-dialog title="Imprimir Etiquetas" center :visible.sync="print.dialog">
      <el-form>
        <el-form-item>
          <el-radio v-model="print.model" label="1"
            >1 por folha (10 x 14) <br />
            <img src="/img/etiueta4x1.png" style="margin-left: 43px"
          /></el-radio>
          <el-radio v-model="print.model" label="2"
            >2 por folha (10 x 14) <br />
            <img src="/img/etiueta4x2.png" style="margin-left: 43px"
          /></el-radio>
          <el-radio v-model="print.model" label="4"
            >4 por folha (10 x 14) <br />
            <img src="/img/etiueta4x4.png" style="margin-left: 43px"
          /></el-radio>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.warning" autocomplete="off"
            >Imprimir Aviso Recebimento</el-checkbox
          >
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.declared" autocomplete="off"
            >Imprimir Declaração Conteudo</el-checkbox
          >
          <el-radio :disabled="!print.declared" v-model="print.type" label="1"
            >Para todas as etiquetas</el-radio
          >
          <el-radio :disabled="!print.declared" v-model="print.type" label="2"
            >Somente que possuem declaração</el-radio
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="print.dialog = false">Cancelar</el-button>
        <el-button type="primary" @click="doprintall">Imprimir</el-button>
      </span>
    </el-dialog>

    <PrePostDC ref="dc" :dialog="dialogdc" v-on:saved="saved" />

    <el-dialog
      :title="$t('ordem-servico')"
      :visible.sync="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="formos">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('descricao')">
              <el-input v-model="formos.observation" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item label="Solicitar coleta" prop="coleta">
              <el-switch
                v-model="formos.coleta"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialog = false">Cancelar</el-button>
        <el-button type="primary" @click="addOrderservices()">Criar</el-button>
      </span>
    </el-dialog>

    <el-card shadow="always">
      <el-form :model="formCardPost">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-page-header
              title
              @back="$router.replace({ name: 'pre.post' })"
              content="Adicionar nova prepostagem"
            ></el-page-header>
          </el-col>
        </el-row>
        <el-row style="padding-top: 10px">
          <PrepostLimitCredit
            ref="limitCredit"
            type="line"
            :customer="customer"
            v-if="customer && limit > 0"
          />
          <el-col
            :xs="24"
            :sm="10"
            :md="10"
            :lg="8"
            :xl="8"
            style="padding-left: 120px"
            v-if="user.type !== '5'"
          >
            <el-form-item
              style="margin-top: -10px"
              class="no-margin-bottom"
              :label="
                user.type === '1' || user.type === '3'
                  ? $t('cliente')
                  : $t('filial')
              "
            >
              <CustomerList
                v-model="customer"
                v-bind:customerType="user.type === '2' ? 3 : 0"
                v-on:selected="selectedCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="6"
            :md="6"
            :lg="8"
            :xl="8"
            v-show="customer && listCardPost.length > 1"
          >
            <el-form-item
              class="no-margin-bottom"
              :label="$t('cartao-postagem')"
            >
              <el-select v-model="cardpost">
                <el-option
                  v-for="record in listCardPost"
                  :key="record.id"
                  :label="record.cardpost.code"
                  :value="record.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>

    <el-card shadow="always" v-if="prepost.length > 0">
      <el-collapse accordion>
        <el-collapse-item name="1">
          <template slot="title">
            <b>Pré-postagens realizadas</b>
            <el-badge :value="prepost.length" class="item"></el-badge>
          </template>
          <PrepostEdit
            v-if="rowModal.open"
            :tag="rowModal.tag"
            :dialog="rowModal.open"
            :state="'VIEW'"
            tab="edit"
            v-on:close="closeRowModal()"
          />
          <el-table @row-dblclick="openRowModal"
            :data="prepost"
            stripe
            ref="tablePrepost"
            style="width: 100%"
            :default-sort="{ prop: 'tag', order: 'ascending' }"
          >
            <el-table-column type="selection" :selectable="canSelectRow" width="60"></el-table-column>
            <el-table-column
              sortable
              prop="service"
              :label="$t('grupo-servico')"
            >
            </el-table-column>
            <el-table-column
              sortable
              prop="tag"
              :label="$t('objeto')"
            >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.statuscourier === 'pendente'" type="info">Não disponível</el-tag>
              <TagLink v-else :tag="scope.row.tag" :back="'pre.post'" :notification="scope.row.notification" />
            </template>
          </el-table-column>
            <el-table-column
              sortable
              prop="sourcezipcode"
              :label="$t('cep-origem')"
            ></el-table-column>
            <el-table-column
              sortable
              prop="destinyzipcode"
              :label="$t('cep-destino')"
            >
            </el-table-column>
            <el-table-column sortable prop="pricetable" :label="$t('valor')">
              <template slot-scope="scope">{{
                scope.row.pricetable
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
              }}</template>
            </el-table-column>

            <el-table-column label="#" width="180">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="remove(scope.row.id, scope.row.tag)"
                  circle
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-row :gutter="5">
            <el-col :xs="24">
              <el-button
                type="default"
                icon="el-icon-printer"
                @click="printall()"
                >Imprimir selecionada</el-button
              >
              <el-button
                type="default"
                icon="el-icon-document"
                @click="dialog = true"
                >Gerar Ordem Serviço</el-button
              >
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <b>Ordem de serviços geradas</b>
            <el-badge :value="orderservices.length" class="item"></el-badge>
          </template>
          <OrderServicesList
            v-bind:records="orderservices"
            v-bind:customer_id="customer"
          />
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <PrePostSender
          ref="sender"
          :labelPosition="labelPosition"
          :customer="customer"
          :state="state.delivery ? 'VIEW' : 'CHANGED'"
          v-on:changed="changed"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <PrePostDeliver
          :labelPosition="labelPosition"
          ref="delivery"
          :customer="customer"
          :state="state.delivery ? 'VIEW' : 'CHANGED'"
          :userType="user.type"
          v-on:confirm="confirmDelivery"
          v-on:changed="changed"
        />
      </el-col>
    </el-row>

    <el-row :gutter="5" v-if="state.delivery">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <PrePostContact
          :labelPosition="labelPosition"
          ref="contact"
          :state="state.object ? 'VIEW' : 'CHANGED'"
          v-on:changed="changedObject"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <PrePostObject
          :labelPosition="labelPosition"
          ref="object"
          :state="state.object ? 'VIEW' : 'CHANGED'"
          v-on:confirm="confirmObject"
          v-on:changed="changedObject"
        />
      </el-col>
    </el-row>

    <el-card shadow="always" v-if="state.delivery && state.object">
      <el-row :gutter="2" style="text-align: center; margin-bottom: 5px">
        <el-col
          :xs="24"
          :sm="8"
          :md="6"
          :lg="4"
          :xl="3"
          v-for="record of values"
          :key="record.code"
          v-show="record.value > 0 || !record.available"
        >
          <el-card
            :ref="record.code"
            shadow="always"
            style="min-height: 235px"
            :body-style="{
              'background-color': record == selectedService ? '#f4f4f5' : '',
            }"
          >
            <img
              v-if="record.image"
              :src="record.image"
              width="100%"
              height="80px"
              class="image"
            />
            <el-row :gutter="5" justify="center" v-if="!record.image">
              <el-col :xs="24" style="text-align: center">
                <span>{{ record.name }}</span
                ><br />
              </el-col>
            </el-row>
            <el-row :gutter="5" justify="center">
              <el-col
                :xs="24"
                v-if="record.available"
                style="text-align: center"
              >
                <el-link @click="selected(record)" type="success">{{
                  record.value
                    | currency("R$ ", 2, {
                      thousandsSeparator: ".",
                      decimalSeparator: ",",
                    })
                }}</el-link>
              </el-col>
              <el-col
                :xs="24"
                v-else-if="!record.available"
                style="text-align: center"
              >
                <el-alert
                  :description="record.description"
                  type="warning"
                  :closable="false"
                >
                </el-alert>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="record.available">
              <el-col :xs="24" style="text-align: center">
                <el-tag
                  v-if="record.deadline && record.description !== 'offline'"
                  type="info"
                  style="margin-top: 3px"
                  size="small"
                >
                  Previsão Entrega</el-tag
                >
                <el-tag
                  v-else-if="record.description === 'offline'"
                  type="warning"
                  class="two-line-tag"
                  style="margin-top: 3px"
                  size="small"
                  >
                  {{ record.deadline.observation  }}
                </el-tag>
                <br />
                <el-tag
                  v-if="record.deadline && record.description !== 'offline'"
                  type="info"
                  style="margin-top: 3px"
                  size="small"
                >
                  <b v-if="deadlineLabel(record)">
                    {{ deadlineLabel(record) }}
                  </b>
                  <b v-else-if="record.deadline.deadline"
                    >{{ countJadlogDays(record.deadline.deadline) }}
                  </b>
                  <i
                    class="el-icon-warning-outline"
                    style="color: #f56c6c"
                    v-if="record.observation"
                    :title="record.observation"
                  ></i>
                </el-tag>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="record.available">
              <el-col :xs="24">
                <el-button
                  type="primary"
                  @click="selected(record)"
                  size="mini"
                  v-show="record !== selectedService"
                  style="margin-top: 3px; width: 100%"
                  >Selecionar</el-button
                >
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <PrePostComplement
        ref="complement"
        state="CHANGED"
        :service="service"
        :package="$refs.object.measure"
        :labelPosition="labelPosition"
        v-if="service"
        v-on:open="open"
        v-on:confirm="add"
        v-on:calcTotal="calcTotal"
      />
    </el-card>

    <PrePostNfeInformation ref="dialogNfe" :dialog="dialognfe" />

    <el-button @click="openDialogNfe" hidden>Abrir Dialog</el-button>
  </div>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { CustomerService } from "@/services/customers/customers.services";
import { OrderServicesService } from "@/services/customers/order.services.services";
import { PrepostService } from "@/services/customers/prepost.services";
import { PriceDeadLineService } from "@/services/customers/price.deadline.service";
import { ServicesService } from "@/services/customers/services.services";
import { ValuesPrepostService } from "@/services/customers/values.prepost.services";
import { UserService } from "@/services/users/user.services";
import { formatDeadlineDays, countJadlogDays } from "@/utils/shipping-deadline";
import OrderServicesList from "@/xpost/views/dashboard/prepost/OrderServicesList";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import PrePostComplement from "./components/PrePostComplement";
import PrePostNfeInformation from "./components/PrePostNfeInformation";
import PrePostContact from "./components/PrePostContact";
import PrePostDC from "./components/PrePostDC";
import PrePostDeliver from "./components/PrePostDeliver";
import PrePostObject from "./components/PrePostObject";
import PrePostSender from "./components/PrePostSender";
import PrepostLimitCredit from "./components/PrepostLimitCredit";
import TagLink from "../../dashboard/prepost/components/TagLink.vue";
import RowModalMixin from "@/xpost/mixins/row-modal";
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";

export default {
  mixins: [RowModalMixin],
  name: "PrePost",
  components: {
    PrepostEdit,
    TagLink,
    PrePostDC,
    PrePostDeliver,
    PrePostSender,
    PrePostContact,
    PrePostObject,
    CustomerList,
    PrePostComplement,
    PrePostNfeInformation,
    OrderServicesList,
    PrepostLimitCredit,
  },
  methods: {
    countJadlogDays,
    deadlineLabel(record) {
      return formatDeadlineDays(record, record.deadline);
    },
    selectedCustomer(customer) {
      const vm = this;
      if (!customer && vm.user.customer) vm.customer = vm.user.customer;
    },
    printall() {
      const vm = this;
      if (vm.$refs.tablePrepost.selection.length == 0) {
        return this.$message({
          type: "error",
          message: "Selecione as pre-postagens para impressão!",
        });
      }
      const tags = vm.$refs.tablePrepost.selection.map((row) => {
        return row.tag;
      });
      if (tags.length > 52) {
        return this.$message({
          type: "error",
          message:
            "Limite máximo para impressão de etiquetas é de 52 etiquetas por vez!",
        });
      }
      vm.print.dialog = true;
    },
    doprintall() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const tags = vm.$refs.tablePrepost.selection.map((row) => {
        return row.tag;
      });
      PrepostService.print(tags, vm.print)
        .then((response) => {
          vm.print.dialog = false;
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `etiqueta-${tags.length}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-prepostagem", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PrepostService.delete(id)
          .then((response) => {
            setTimeout(() => {
              vm.prepost.splice(
                vm.prepost.findIndex((x) => x.tag === name),
                1
              );
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("prepostagem-eliminada-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              duration: 5000,
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
    confirmDelivery() {
      const vm = this;
      if (!vm.$refs.sender.validate() || !vm.$refs.delivery.validate()) {
        return this.$message({
          type: "error",
          message: "É obrigatório informar todos os campos obrigatórios!",
          duration: 5000,
        });
      }
      if (!vm.cardpost) {
        return this.$message({
          type: "error",
          message: "É obrigatório informar um cartão de postagem!",
          duration: 5000,
        });
      }
      vm.state.delivery = true;
    },
    changed() {
      const vm = this;
      vm.state.delivery = false;
      vm.selectedService = null;
      vm.service = null;
    },
    confirmObject() {
      const vm = this;

      if (!vm.$refs.contact.validate()) {
        return this.$message({
          type: "error",
          message: "É obrigatório informar todos os campos obrigatórios!",
          duration: 5000,
        });
      }
      if (
        !vm.$refs.object.objectForm.weight ||
        vm.$refs.object.objectForm.weight <= 0
      ) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: "É obrigatório informar o peso superior a 0!",
        });
      }
      if (vm.malha && !vm.$refs.contact.contactForm.phone) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: "Cliente de malha é obrigatório informar o telefone!",
        });
      }

      vm.selectedService = null;
      vm.service = null;
      vm.values = [];
      const data = {
        sourceZipcode: vm.$refs.sender.remetenteForm.cep,
        sourceAddress: vm.$refs.sender.remetenteForm.address || '',
        sourceNumber: vm.$refs.sender.remetenteForm.number || '',
        sourceNeighborhood: vm.$refs.sender.remetenteForm.neighborhood || '',
        sourceCity: vm.$refs.sender.remetenteForm.city || '',
        sourceState: vm.$refs.sender.remetenteForm.state || '',
        sourceComplement: vm.$refs.sender.remetenteForm.extent || '',
        destinyZipcode: vm.$refs.delivery.deliveryForm.cep,
        destinyAddress: vm.$refs.delivery.deliveryForm.address || '',
        destinyNumber: vm.$refs.delivery.deliveryForm.number || '',
        destinyNeighborhood: vm.$refs.delivery.deliveryForm.neighborhood || '',
        destinyCity: vm.$refs.delivery.deliveryForm.city || '',
        destinyState: vm.$refs.delivery.deliveryForm.state || '',
        destinyComplement: vm.$refs.delivery.deliveryForm.extent || '',
        weight: vm.$refs.object.objectForm.weight,
        customer: vm.customer,
        branch: vm.$refs.delivery.deliveryForm.branch,
        warning: vm.$refs.object.objectForm.ar,
        ownhand: vm.$refs.object.objectForm.ownhand,
        digital: vm.$refs.object.objectForm.ardigital,
      };
      const loading = vm.$loading(vm.$options.loading);

      vm.state.object = true;
      ValuesPrepostService.values(data)
        .then((response) => {
          if (response.length === 0) {
            return this.$message({
              duration: 5000,
              type: "error",
              message:
                "Não foram encontrados serviços disponíveis para essas regiões!",
            });
          }
          vm.values = response;
          //vm.available();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    available() {
      /*      const vm = this;
      for (const row of vm.values.filter((x) => x.check === true)) {
        ValuesPrepostService.check({
          service: row.service,
          sourceZipcode: vm.$refs.sender.remetenteForm.cep,
          destinyZipcode: vm.$refs.delivery.deliveryForm.cep,
        })
          .then((values) => {
            const data = values.data;
            row.available = data.available;
            row.check = false;
            row.description = "Serviço não disponível!";
            row.deadline = data.deadline;
            row.observation = data.observation;
          })
          .catch((error) => {
            throw error;
          });
      }
*/
      /*      Promise..all(request)*/
    },
    changedObject() {
      const vm = this;
      vm.state.object = false;
    },
    fetchCustomer() {
      const vm = this;
      CustomerService.get(vm.customer).then((response) => {
        vm.limit = +response.limit;
        vm.services = response.service;
        vm.listCardPost = response.cardpost;
        vm.malha = response.malha;
        vm.cardpost = "";
        if (vm.listCardPost.length === 1) {
          vm.cardpost = vm.listCardPost[0].id;
        } else {
          const record = vm.listCardPost.find((x) => x.principal == true);
          if (record) {
            vm.cardpost = record.id;
          }
        }
      });
    },
    selected(service) {
      const vm = this;
      vm.selectedService = service;
      vm.$loading(vm.$options.loading);

      // Reset component
      if (vm.$refs.complement) {
        //vm.$refs.complement.reset();
      }
      ServicesService.code(vm.selectedService.service)
        .then((response) => {
          vm.service = response;
          vm.calcTotal();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        });
    },
    add() {
      const vm = this;
      if (!vm.selectedService) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: "Selecione o serviço desejado!",
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      const complementForm = vm.$refs.complement.isJadlog
        ? vm.$refs.complement.complementForms
        : vm.$refs.complement.complementForm;

      const selectedServiceData = vm.values.find(
        (x) => x.service === vm.selectedService.service
      );
      const pricetable = (selectedServiceData && selectedServiceData.value) || 0;

      PrepostService.add(
        vm.customer,
        vm.$refs.sender.remetenteForm,
        vm.$refs.delivery.deliveryForm,
        vm.$refs.contact.contactForm,
        vm.$refs.object.objectForm,
        complementForm,
        vm.selectedService.service,
        vm.cardpost,
        vm.items,
        vm.$refs.complement.dataNf,
        '',
        pricetable,
      )
        .then((response) => {
          vm.state.delivery = false;
          vm.state.object = false;
          vm.prepost = [...vm.prepost, ...response];
          vm.items = [];
          vm.$refs.dc.clear();
          vm.$refs.sender.clear();
          vm.$refs.delivery.clear();
          vm.$refs.contact.clear();
          vm.$refs.object.clear();
          vm.$refs.sender.remetenteForm.contact = vm.user.name;

          if (vm.$refs.limitCredit) vm.$refs.limitCredit.fetch();

          this.$message({
            type: "success",
            message: `Prepostagem adicionada com sucesso!`,
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());

      OrderServicesService.findOpenByCustomer(vm.customer)
        .then((response) => (vm.orderservices = response))
        .catch((error) =>
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          })
        );
    },
    open() {
      const vm = this;
      vm.dialogdc = true;
    },
    calculateCubicWeight(volumes) {
      // Only calculate if there are volumes
      if (!volumes || volumes.length === 0) return 0;
      
      // Calculate total cubic weight across all volumes
      const totalCubicWeight = volumes.reduce((total, volume) => {
        const { height, width, length } = volume;
        if (!height || !width || !length) return total;
        const cubicWeight = ((height * width * length * 167) / 1000000);
        return total + cubicWeight;
      }, 0);

      // Round to nearest integer
      return Number((totalCubicWeight * 10).toFixed(0));
    },
    calcTotal() {
      var vm = this;
      const loading = vm.$loading(vm.$options.loading);
      
      let finalWeight = vm.$refs.object.objectForm.weight;

      // Only calculate cubic weight for JADLOG services
      if (vm.service.modalityCode) {
        const volumes = vm.$refs.complement ? vm.$refs.complement.complementForms || [] : [];
        const cubicWeight = vm.calculateCubicWeight(volumes);
        finalWeight = Math.max(cubicWeight, finalWeight);
      }

      // MUDAR AQUI
      const hasNf = vm.$refs.complement && vm.$refs.complement.hasNf ? vm.$refs.complement.hasNf : false;
      const format = vm.$refs.complement ? vm.$refs.complement.complementForm.type : '001';
      const length = vm.$refs.complement ? vm.$refs.complement.complementForm.length : vm.$refs.object.measure.length || +vm.service.lengthmin
      const height = vm.$refs.complement ? vm.$refs.complement.complementForm.height : vm.$refs.object.measure.height || +vm.service.heightmin
      const width = vm.$refs.complement ? vm.$refs.complement.complementForm.width : vm.$refs.object.measure.width || +vm.service.widthmin
      const diameter = vm.$refs.complement ? vm.$refs.complement.complementForm.diameter : vm.$refs.object.measure.diameter || +vm.service.diametermin

      PriceDeadLineService.deadLinePrice({
        service: vm.selectedService.service,
        source: vm.$refs.sender.remetenteForm.cep,
        sourceState: vm.$refs.sender.remetenteForm.state || '',
        destiny: vm.$refs.delivery.deliveryForm.cep,
        destinyAddress: vm.$refs.delivery.deliveryForm.address || '',
        destinyNumber: vm.$refs.delivery.deliveryForm.number || '',
        destinyNeighborhood: vm.$refs.delivery.deliveryForm.neighborhood || '',
        destinyCity: vm.$refs.delivery.deliveryForm.city || '',
        destinyState: vm.$refs.delivery.deliveryForm.state || '',
        destinyComplement: vm.$refs.delivery.deliveryForm.extent || '',
        weidth: finalWeight, // Use the calculated final weight
        format,
        length,
        height,
        width,
        diameter,
        digital: vm.$refs.object.objectForm.ardigital,
        ownhand: vm.$refs.object.objectForm.ownhand,
        valuedeclared: vm.$refs.complement ? vm.$refs.complement.complementForm.value : 0,
        warning: vm.$refs.object.objectForm.ar,
        customer: vm.customer,
        branch: vm.$refs.delivery.deliveryForm.branch,
        volumes: vm.$refs.complement ? vm.$refs.complement.complementForms : [],
        dataNf: vm.$refs.complement ? vm.$refs.complement.dataNf : null,
        hasNf,
      })
        .then((response) => {
          const record = vm.values.find(
            (x) => x.service === vm.selectedService.service
          );
          if (record && response.pricetable > 0) {
            record.value = response.pricetable;
          }
          if (response.message) {
            return this.$message({
              type: "warning",
              message: response.message,
              duration: 5000,
            });
          }
          vm.aditional = response;
        })
        .catch((error) => {
          return this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    addOrderservices() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const data = {
        observation: vm.formos.observation,
        colection: vm.formos.coleta,
        requester: vm.user.name,
        customer: vm.customer,
        plp: true,
        departament: "",
        prepost: vm.$refs.tablePrepost.selection,
      };
      OrderServicesService.add(data)
        .then((response) => {
          vm.dialog = false;
          vm.formos.observation = "";
          vm.formos.coleta = false;
          vm.orderservices.push(response);
          this.$message({
            type: "success",
            message: "Ordem de Serviço adicionada com sucesso!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    saved(list) {
      const vm = this;
      vm.items = list;
      vm.dialogdc = false;
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      PrepostService.list()
        .then(async (response) => {
          vm.prepost = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    onresize() {
      const vm = this;
      const { offsetWidth, offsetHeight } = document.querySelector("#app");
      if (offsetWidth < 767) {
        vm.labelPosition = "top";
      } else {
        vm.labelPosition = "right";
      }
    },
    openDialogNfe() {
      const vm = this;
      vm.dialognfe = true;
    },
    canSelectRow(row, index) {
      return row.status !== '2';
    }    
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.customer = v;
      vm.fetchCustomer();
    },
  },
  mounted() {
    const vm = this;
    vm.onresize();
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user.name = response.name;
        vm.malha = response.customers ? response.customers.malha : false;
        vm.$refs.sender.remetenteForm.contact = response.name;
        if (response.type == "2" || response.type == "5") {
          vm.user.customer = response.customers.id;
          vm.limit = +response.limit;
          vm.customer = response.customers.id;
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          duration: 5000,
          message: error,
        });
      });
  },
  data() {
    return {
      customer: "",
      limit: 0,
      malha: false,
      user: {
        type: "2",
        name: "",
        customer: null,
      },
      labelPosition: "right",
      message: true,
      cardpost: "",
      listCardPost: [],
      print: {
        model: "4",
        warning: true,
        declared: true,
        type: "1",
        dialog: false,
        dialogNfe: false,
      },
      formCardPost: {
        cardpost: "",
      },
      service: null,
      selectedService: "",
      services: [],
      state: {
        delivery: false,
        object: false,
      },
      aditional: {
        warning: 0,
        ownhand: 0,
        declaredValue: 0,
        machine: 0,
      },
      values: [],
      confirm: false,
      confirm2: false,
      dialogdc: false,
      dialog: false,
      dialognfe: false,
      filter: "",
      prepost: [],
      orderservices: [],
      tableData: [],
      items: [],
      activeName: "1",
      remetenteForm: {
        cep: "",
      },
      formos: {
        observation: "",
        coleta: false,
      },
    };
  },
};
</script>

<style>
.right {
  float: right;
}

.label {
  font-weight: bold;
}

.item {
  margin-top: 10px;
  margin-right: 40px;
}

.el-badge__content.is-fixed {
  z-index: 999;
}

.no-margin-bottom {
  margin-bottom: 0px !important;
}

.fixed {
  min-width: 80px;
}
.two-line-tag {
  /* Allow height to adjust dynamically based on content */
  height: auto;
  padding-top: 4px;
  padding-bottom: 4px;
  
  /* Reset the default rigid white-space constraint */
  white-space: normal;
  
  /* Force line clamping behavior for exactly 2 lines */
  display: inline-flex;
  align-items: center;
  
  /* Standard webkit line clamping */
  display: -webkit-inline-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  /* Adjust default line height so text matches standard formatting */
  line-height: 1.4; 
}
</style>
